import { useScrollEvent } from "hooks/useScrollEvent";
import { handleAmpliLoaded } from "helpers/handleAmpliLoaded";
import { useEffect, useRef } from "react";
import { ampli } from "services/ampli";
import { checkAbTest } from "helpers/checkAbTest";
import { useAppData } from "providers/RootStoreProvider";
import { LandingType } from "constants/landing-variants.const";

export const useLandingEvents = ({ landingType }: { landingType: LandingType }) => {
    const { flowOuter, abTestData, isAttributionSent } = useAppData();
    const abLandingTest = abTestData?.["abTestLanding"];
    const isLandingShownRef = useRef(false);

    const landing_type = flowOuter ? `[${abLandingTest}] ${landingType}` : LandingType.DEFAULT;

    const landingTryNowClick = () => {
        handleAmpliLoaded(() => ampli.landingTryNowClick({ landing_type }));
    };

    useScrollEvent(() => {
        if (isAttributionSent && landing_type) {
            handleAmpliLoaded(() => ampli.landingScroll({ landing_type }));
        }
    });

    useEffect(() => {
        if (!isLandingShownRef.current && isAttributionSent && landing_type) {
            const ab_paywall = checkAbTest("abTestPaywall", true);
            const ab_auth = checkAbTest("abTestAuth");
            const ab_contact = checkAbTest("abTestContact");

            const params = {
                ab_paywall,
                ab_auth,
                landing_type,
                ab_contact,
            };

            isLandingShownRef.current = true;
            handleAmpliLoaded(() => ampli.landingScreenShown(params));
        }
    }, [ampli.isLoaded, isAttributionSent, landing_type]);

    return { landingTryNowClick };
};
